module.exports = __webpack_public_path__ + "img/copy.907fc1e1.png";